<template>
  <span class="kds-live-indicator" role="status" aria-live="polite">
    <span class="kds-live-indicator__dot kds-pulse-dot" />
    <span class="kds-live-indicator__label">
      LIVE
      <span class="kds-live-indicator__sep">·</span>
      TURN {{ turn }} / {{ total }}
    </span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  turn: number;
  total: number;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.kds-live-indicator {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: 4px 12px;
  background: var(--signal-tint);
  border: var(--bw) solid var(--signal-press);
  border-radius: var(--r-pill);
  color: var(--ink);

  &__dot {
    width: 6px;
    height: 6px;
    background: var(--signal);
    border-radius: var(--r-pill);
  }

  &__label {
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  &__sep {
    color: var(--stone-2);
    margin: 0 var(--space-1);
  }
}
</style>
